import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        InspectorAdvancedControls,
        MediaUpload
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        Button,
        TextControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/gallery-3', {
        // built-in attributes
        title: 'Gallery 3',
        description: 'Gallery with three images.',
        icon: '',
        category: 'custom-gallery',
        example: {},

        // custom attributes
        attributes: {
            image1: {
                type: 'string',
                default: ''
            }, 
            alt1: {
                type: 'string',
                default: ''
            },
            image2: {
                type: 'string',
                default: ''
            }, 
            alt2: {
                type: 'string',
                default: ''
            },
            image3: {
                type: 'string',
                default: ''
            }, 
            alt3: {
                type: 'string',
                default: ''
            },
            anchor: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                image1,
                alt1,
                image2,
                alt2,
                image3,
                alt3,
                classes,
                anchor
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            
            // custom functions
            function onSelectImage1(image1) {
                setAttributes({alt1: image1.alt});
                setAttributes({image1: image1.sizes.full.url});
            }

            function onSelectImage2(image2) {
                setAttributes({alt2: image2.alt});
                setAttributes({image2: image2.sizes.full.url});
            }

            function onSelectImage3(image3) {
                setAttributes({alt3: image3.alt});
                setAttributes({image3: image3.sizes.full.url});
            }

            return ([
                <>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>
                            <MediaUpload 
                                onSelect={ onSelectImage1 }
                                type="image"
                                value={ image1 } 
                                render={ ( { open } ) => (
                                    <div>
                                        { image1 && 
                                            <div>
                                                <figure>
                                                    <img src={ image1 } />
                                                </figure>
                                                <div>
                                                    <Button onClick={() => setAttributes({ image1: '' })} className="button">Remove</Button>
                                                </div>
                                                <br></br>
                                            </div>
                                    
                                        }
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        Select First Image
                                    </IconButton>
                                    </div>
                                ) }  />
                            <MediaUpload 
                                onSelect={ onSelectImage2 }
                                type="image"
                                value={ image2 } 
                                render={ ( { open } ) => (
                                    <div>
                                        { image2 && 
                                            <div>
                                                <figure>
                                                    <img src={ image2 } />
                                                </figure>
                                                <div>
                                                    <Button onClick={() => setAttributes({ image2: '' })} className="button">Remove</Button>
                                                </div>
                                                <br></br>
                                            </div>
                                    
                                        }
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        Select Second Image
                                    </IconButton>
                                    </div>
                                ) }  />
                            <MediaUpload 
                                onSelect={ onSelectImage3 }
                                type="image"
                                value={ image3 } 
                                render={ ( { open } ) => (
                                    <div>
                                        { image3 && 
                                            <div>
                                                <figure>
                                                    <img src={ image3 } />
                                                </figure>
                                                <div>
                                                    <Button onClick={() => setAttributes({ image3: '' })} className="button">Remove</Button>
                                                </div>
                                                <br></br>
                                            </div>
                                    
                                        }
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        Select Second Image
                                    </IconButton>
                                    </div>
                                ) }  />
                        </PanelBody>
                    </InspectorControls>
                    <InspectorAdvancedControls>
                        <TextControl
                            __nextHasNoMarginBottom
                            __next40pxDefaultSize
                            label="HTML anchor"
                            value={ anchor }
                            onChange={ ( anchor ) => {
                                setAttributes( {
                                    anchor: anchor,
                                } );
                            } }
                        />
                    </InspectorAdvancedControls>
                </>
                ,

                <div id={ anchor } className={ "photo-gallery-3" + (classes ? ' ' + classes : '') }>
                    <div className="row">
                        <div className="col">
                            <div className="photo-1">
                                <img className="cover-image" src={ image1 } alt={ alt1 } />
                            </div>
                        </div>
                        <div className="col">
                            <div className="row">
                                <div className="col-12">
                                    <div className="photo-2">
                                        <img className="cover-image" src={ image2 } alt={ alt2 } />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="photo-3">
                                        <img className="cover-image" src={ image3 } alt={ alt3 } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ]);
        },

        save({ attributes }) {

            const {
                image1,
                alt1,
                image2,
                alt2,
                image3,
                alt3,
                classes,
                anchor
            } = attributes;

            return (
                <div id={ anchor } className={ "photo-gallery-3" + (classes ? ' ' + classes : '') }>
                    <div className="row g-2">
                        <div className="col">
                            <div className="photo-1">
                                <img className="lozad cover-image" data-src={ image1 } alt={ alt1 } />
                            </div>
                        </div>
                        <div className="col">
                            <div className="row g-2">
                                <div className="col-12">
                                    <div className="photo-2">
                                        <img className="lozad cover-image" data-src={ image2 } alt={ alt2 } />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="photo-3">
                                        <img className="lozad cover-image" data-src={ image3 } alt={ alt3 } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    });
}